import { render } from "./ChoosedDocs.vue?vue&type=template&id=a1f1fdec&ts=true"
import script from "./ChoosedDocs.vue?vue&type=script&lang=ts"
export * from "./ChoosedDocs.vue?vue&type=script&lang=ts"

import "./ChoosedDocs.vue?vue&type=style&index=0&id=a1f1fdec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__